import axios from "axios";
import apiUrl from "../../Apiurl";

const CODICE_FONTE_NON_DISPONIBILE = "PRESTASHOP_FONTE_NON_DISPONIBILE";

function leggiBlob(blob) {
    return new Promise((resolve, reject) => {
        const lettore = new FileReader();
        lettore.onload = () => resolve(lettore.result);
        lettore.onerror = () => reject(lettore.error);
        lettore.readAsText(blob);
    });
}

// Con responseType 'blob' anche il JSON d'errore della API arriva come Blob.
async function leggiErroreApi(err) {
    const data = err?.response?.data;
    if (!data) {
        return null;
    }
    try {
        const testo = data instanceof Blob ? await leggiBlob(data) : data;
        return typeof testo === "string" ? JSON.parse(testo) : testo;
    } catch (errLettura) {
        return null;
    }
}

function descriviFonti(fonti) {
    return fonti.map(fonte => `${fonte.nomeSito} (${fonte.numeroOrdini})`).join(" e ");
}

const scaricaPdf = async function(token, idSpedizioni, fonti) {
    const config = {
        headers: {
            'Authorization': 'Bearer ' + token,
        },
        responseType: 'blob',
    };
    const response = await axios.post(
        apiUrl + "/logistica/pdf/ordiniByIDPrestashopUnificati",
        fonti ? { idSpedizioni, fonti } : { idSpedizioni },
        config,
    );

    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'ordini.pdf');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

const stampaFormatoPSdaIDsped = async function(token,ordiniSelezionati) {
    if (!token) {
        console.warn("sto aspettando un token")
        return;
    }
    const idSpedizioni = [...new Set(ordiniSelezionati
        .map(ord => typeof ord === "object" && ord !== null ? (ord.idSped || ord.id) : ord)
        .filter(id => /^\d+$/.test(String(id).trim()))
        .map(id => Number(id)))];

    if (!idSpedizioni.length) {
        console.warn("Nessuna spedizione valida da stampare");
        return;
    }

    let fonti = null;
    // Al massimo un secondo tentativo, limitato alle fonti che hanno risposto.
    for (let tentativo = 0; tentativo < 2; tentativo += 1) {
        try {
            await scaricaPdf(token, idSpedizioni, fonti);
            return;
        } catch (err) {
            console.error('Errore durante il download del PDF', err);
            const errore = await leggiErroreApi(err);
            if (errore?.codice !== CODICE_FONTE_NON_DISPONIBILE) {
                const dettaglioRisposta = err?.response
                    ? `HTTP ${err.response.status}`
                    : "nessuna risposta leggibile dal server";
                alert(errore?.error || `Errore durante la stampa degli ordini PrestaShop (${dettaglioRisposta})`);
                return;
            }
            const disponibili = errore.fontiDisponibili || [];
            const dettaglio = (errore.fontiNonDisponibili || [])
                .map(fonte => `${fonte.nomeSito}: ${fonte.motivo}`)
                .join("\n");
            if (fonti || !disponibili.length) {
                alert(`${errore.error}.\n\n${dettaglio}\n\nRiprova più tardi.`);
                return;
            }
            const conferma = window.confirm(
                `${errore.error}.\n\n${dettaglio}\n\n`
                + `Vuoi stampare solo gli ordini ${descriviFonti(disponibili)}?\n`
                + `Gli ordini ${descriviFonti(errore.fontiNonDisponibili || [])} andranno stampati a parte.`
            );
            if (!conferma) {
                return;
            }
            fonti = disponibili.map(fonte => fonte.fonte);
        }
    }
};

export default stampaFormatoPSdaIDsped;
